<div class='contact-input'>
  <div #optionListGroup class="option-list-group" (click)="onInputFocus(true)">
    <input #input type="text" class="form-control" (change)="onInputChange()" (keyup)="onInputChange()" (focus)="onInputFocus(true)" />
    <div class="option-list-wrapper">
      <div [style.width.px]="contactDropdownWidth" [ngClass]="{'option-list' : true, 'expand': showOptions && ((isFiltered && filteredList.length > 0) || (!isFiltered && visibleList.length > 0))}">
        <div class="option" *ngFor="let option of (isFiltered ? filteredList : visibleList).slice(0, 4)" (click)="onSelectOption(option)">
          <div class="identifier">
            <span class="name">{{ option.name }}</span>
            <span class="email">{{ option.email }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="select-list-wrapper">
    <div class="select-list">
      <div class="option" *ngFor="let option of selectList">
        <div class="identifier">
          <i class="fa fa-user" aria-hidden="true"></i>
          <span class="name">{{ option.name }}</span>
        </div>
        <span class="actions">
          <button (click)="onRemoveSelected(option)" type="button" class="btn btn-danger btn-xs" title="Remove"><i class="fa fa-trash-o"></i></button>
        </span>
      </div>
    </div>
  </div>
</div>
